import {
  Box, Table, TableBody, TableCell, TableHead, TableRow,
  TextField, Typography, Accordion, AccordionSummary, AccordionDetails
} from '@mui/material'
import React, { useState, useEffect } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { COMMON_STYLE, UMA_IOL_MASTER_LIST } from '../../../../Utility/Constants'
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const iolMasterState = {
  patientId: '',
  doctorId: '',
  appointmentId: '',
  clinicId: '',
  iolMasterData: [],
  iolComments: '',
  dupIolMasterData: '[]',
  dupIolComments: ''
}

const UmaIolMaster = React.forwardRef((props, ref) => {
  const [iolMaster, setIolMaster] = useState(iolMasterState)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: message,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: message,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  React.useImperativeHandle(ref, () => ({
    performIolMasterAction: () => {
      if (
        (JSON.stringify(iolMaster.iolMasterData) !== iolMaster.dupIolMasterData) ||
        (JSON.stringify(iolMaster.iolComments) !== iolMaster.dupIolComments)
      ) {
        postIolMasterData()
      }
    }
  }))

  const apicalls = async () => {
    await getIOLMasterData()
  }

  useEffect(() => {
    const hasIolData = iolMaster?.iolMasterData?.some(item => item.le_eye?.trim() || item.re_eye?.trim());
    props.setAccordionOpen((hasIolData || (iolMaster.iolComments?.trim())) ? true : false);
  }, [iolMaster?.iolMasterData, iolMaster.iolComments])

  const getIOLMasterData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_IOL_MASTER + '?appointment_id=' + props?.props?.appointment_id + '&doctor_id=' + props?.props?.doctorID)

      if (response?.data?.status === 'success') {
        let iolData = response?.data?.data !== null ? response?.data?.data : {}
        setIolMaster((prev) => ({
          ...prev,
          iolMasterData: Object.keys(iolData)?.length > 0 ? iolData?.iol_data : UMA_IOL_MASTER_LIST,
          dupIolMasterData: Object.keys(iolData)?.length > 0 ? JSON.stringify(iolData?.iol_data) : JSON.stringify(UMA_IOL_MASTER_LIST),
          iolComments: Object.keys(iolData)?.length > 0 ? iolData?.comments : '',
          dupIolComments: Object.keys(iolData)?.length > 0 ? JSON.stringify(iolData?.comments) : JSON.stringify('')
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const postIolMasterData = async () => {
    try {
      let data = {
        appointment_id: props?.props?.appointment_id,
        iol_data: iolMaster.iolMasterData,
        comments: iolMaster.iolComments
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_IOL_MASTER)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getIOLMasterData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error?.message)
      }
    }
  }

  const textBox = (names, values, index, label) => {
    try {
      return (
        <TextField
          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
          autoComplete='off'
          size='small'
          sx={{ width: '10vw' }}
          value={values}
          onChange={(e) => {
            let iolData = [...iolMaster.iolMasterData]
            iolData[index] = { ...iolData[index], [names]: e.target.value }
            setIolMaster((prev) => ({ ...prev, iolMasterData: iolData }))
          }}
          InputProps={{ style: { height: COMMON_STYLE.HEIGHT }, emed_tid: names }}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Accordion expanded={props.accordionOpen}
          onChange={(_, isExpanded) => {
            props.setAccordionOpen(isExpanded, true);
          }}>
          <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
            <Typography className='doc_notes_header_card_font'>IOL Master</Typography>
          </AccordionSummary>
          <AccordionDetails component={'div'} m={'0.5rem'}>
            <Box component={'div'} border={'1px solid lightgray'}>
              <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell className='doc_notes_tbl_header'>Curvature Value</TableCell>
                    <TableCell className='doc_notes_tbl_header'>Right Eye</TableCell>
                    <TableCell className='doc_notes_tbl_header'>Left Eye</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {iolMaster?.iolMasterData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.label ? item?.label : '-'}</TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {textBox('re_eye', item?.re_eye, index, item?.label)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {textBox('le_eye', item?.le_eye, index, item?.label)}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </Box>
            <Box component={'div'} mt={'0.5rem'}>
              <TextField
                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                size='small'
                multiline
                fullWidth
                maxRows={5}
                value={iolMaster?.iolComments}
                onChange={(e) => {
                  let value = e.target.value
                  if (value?.length <= COMMON_STYLE.CHAR_LIMIT_DESP || value === '') {
                    setIolMaster((prev) => ({ ...prev, iolComments: value }))
                  }
                }}
                placeholder='Comments'
                InputProps={{ emed_tid: 'iol_cmts' }}
              />
            </Box>
          </AccordionDetails>
        </Accordion>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaIolMaster